import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import IMarketingChannels from '../../../app/_interfaces/IMarketingChannels';

@Injectable({
  providedIn: 'root',
})
export class MarketingChannelsService {
  constructor(private http: HttpClient) {}

  getAll(customers_id: number) {
    return this.http.get<IMarketingChannels[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/marketing-channels`
    );
  }

  get(customers_id: number, marketing_channels_id: number) {
    return this.http.get<IMarketingChannels[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/marketing-channels/${marketing_channels_id}`
    );
  }

  create(customers_id: number, marketingChannel: IMarketingChannels) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/marketing-channels/`,
      marketingChannel
    );
  }

  update(
    customers_id: number,
    marketing_channels_id,
    marketingChannel: IMarketingChannels
  ) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/marketing-channels/${marketing_channels_id}`,
      marketingChannel
    );
  }

  delete(customers_id: number, marketing_channels_id: number) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/marketing-channels/${marketing_channels_id}`
    );
  }
}
